import { useState } from 'react';

const Contact = () => {
    const [name, setName] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        const text =
            `Name: ${name}
Subject: ${subject}
Message: ${message}`
            ;

        const encodedText = encodeURIComponent(text);
        const url = `https://wa.me/6282142762543?text=${encodedText}`;

        window.open(url, "_blank");

        // clear form after submit
        setName('');
        setSubject('');
        setMessage('');
    };

    const isDisabled = !name || !subject || !message;

    return (
        <section className="bg-black" id="contact">
            <div className="max-w-7xl mx-auto px-4 py-14 sm:py-20">
                <div className="mb-2 sm:mb-5">
                    <h2 className="font-semibold text-white text-4xl md:text-6xl">Let's <span className="text-primary pridi">Connect</span>.</h2>
                    <p className="font-light text-sm sm:text-base text-white/70 w-full md:w-1/2">
                        need help, consultation, talk about random things, playing games, and connect with me.
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col justify-center gap-3 min-w-0">
                        {[
                            { label: 'Discord', value: 'deva3xd' },
                            { label: 'Github', value: 'deva3xd' },
                            { label: 'Gmail', value: 'devarn05@gmail.com' },
                            { label: 'Instagram', value: '@deva3xd_' },
                            { label: 'LinkedIn', value: 'deva rahma nugroho' },
                        ].map(({ label, value }) => (
                            <div key={label} className="flex gap-3 min-w-0">
                                <span className="w-20 sm:w-24 shrink-0 text-xs text-white/70 flex items-center">{label}</span>
                                <span className="min-w-0 font-semibold text-white underline underline-offset-4 break-words">{value}</span>
                            </div>
                        ))}
                    </div>
                    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                        <div>
                            <label htmlFor="name" className="text-white text-sm">Name</label>
                            <input
                                id="name"
                                name="name"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="border border-primary text-black bg-gray-300 outline focus:outline-primary w-full p-3" placeholder="Name"
                            />
                        </div>
                        <div>
                            <label htmlFor="subject" className="text-white text-sm">Subject</label>
                            <input
                                id="subject"
                                name="subject"
                                type="text"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                className="border border-primary text-black bg-gray-300 outline focus:outline-primary w-full p-3" placeholder="Subject"
                            />
                        </div>
                        <div>
                            <label htmlFor="message" className="text-white text-sm">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                className="border border-primary text-black bg-gray-300 outline focus:outline-primary w-full p-3" placeholder="Message"
                            />
                        </div>
                        <button type="submit" className="text-center w-full bg-primary hover:bg-primary/90 font-bold py-3 disabled:bg-primary/70" disabled={isDisabled}>Send to WhatsApp</button>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default Contact
